module.exports = __webpack_public_path__ + "bed-record-box.8219f8cc.png";